import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import LessonOverview from './LessonOverview';
import ProfessorList from './ProfessorList';
import ResourcesList from './ResourcesList';
import UsageTracker from '../../utils/UsageTracker';
import { useLessonContentById } from '../../features/lessons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LessonInfoTabs = ({
  contentId,
  lesson,
  onResourceClick,
  trackId
}) => {
  const {
    isTablet
  } = useMediaQuery();
  const content = useLessonContentById({
    lessonId: lesson.get('id'),
    contentId: Number(contentId),
    language: lesson.get('language'),
    fetchPolicy: trackId ? 'cache-only' : 'cache-first'
  });
  const onTabChange = event => UsageTracker.track('interaction', {
    action: 'lesson-info-tab-clicked',
    tab: event.target.value
  });
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => UsageTracker.track('interaction', {
    action: 'professor-organisation-click',
    contentType: 'LESSON',
    appearsIn: 'lessons',
    organisation,
    organisationUrl,
    professorId,
    lessonId: lesson.get('id'),
    contentId
  });
  const professors = lesson.get('professors') || [];
  return /*#__PURE__*/_jsxs(Tabs, {
    defaultSelected: "lesson-info",
    fill: true,
    inlineSize: isTablet ? '100vw' : undefined,
    onSelectedChange: onTabChange,
    children: [/*#__PURE__*/_jsx(Tab, {
      padding: isTablet ? '250' : undefined,
      tabId: "lesson-info",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.aboutThisLesson"
      }),
      children: /*#__PURE__*/_jsx(LessonOverview, {
        description: lesson.get('description'),
        hubId: content === null || content === void 0 ? void 0 : content.hubId
      })
    }), professors.length > 0 && /*#__PURE__*/_jsx(Tab, {
      padding: isTablet ? '250' : undefined,
      tabId: "lesson-professors",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.lessonInformation.professors",
        options: {
          count: professors.length
        }
      }),
      children: /*#__PURE__*/_jsx(ProfessorList, {
        handleOrganisationUrlClick: handleOrganisationUrlClick,
        i18nHeading: "learningCenter.lessonInformation.professors",
        professors: professors
      })
    }), /*#__PURE__*/_jsx(Tab, {
      padding: isTablet ? '250' : undefined,
      tabId: "resources",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.resources.title"
      }),
      children: /*#__PURE__*/_jsx(ResourcesList, {
        additionalResources: lesson.get('learningMaterials') ? lesson.get('learningMaterials').toJS() : undefined,
        i18nHeading: "learningCenter.lessonResources",
        i18nNoResources: "learningCenter.noLessonResources",
        onResourceClick: onResourceClick,
        slidesUrl: lesson.get('slidesUrl'),
        transcriptUrl: lesson.get('transcriptUrl')
      })
    })]
  });
};
export default LessonInfoTabs;